import { gql } from '@apollo/client'

export const OPERATION_CHECKOUT_ROOM = gql`
  mutation CheckoutRoom($sf_id: String!, $room_id: Int) {
    checkoutRoom(sf_id: $sf_id, room_id: $room_id) {
      id
      wifi_psk
    }
  }
`

export const OPERATION_CREATE_MESSAGE = gql`
  mutation CreateMessage($sf_id: String!, $title: String!, $content: String!) {
    message: createMessage(sf_id: $sf_id, title: $title, content: $content) {
      id
      site_sf_id
      title
      content
      enable
    }
  }
`

export const OPERATION_DELETE_MESSAGE = gql`
  mutation DeleteMessage($sf_id: String!, $message_id: String!) {
    deleteMessage(sf_id: $sf_id, message_id: $message_id) {
      status
    }
  }
`

export const OPERATION_DISABLE_MESSAGE = gql`
  mutation DisableMessage($sf_id: String!, $message_id: String!) {
    disableMessage(sf_id: $sf_id, message_id: $message_id) {
      id
      enable
    }
  }
`

export const OPERATION_ENABLE_MESSAGE = gql`
  mutation EnableMessage($sf_id: String!, $message_id: String!) {
    enableMessage(sf_id: $sf_id, message_id: $message_id) {
      id
      enable
    }
  }
`

export const OPERATION_REBOOT_DEVICE = gql`
  mutation RebootRoomDevice($sf_id: String!, $device_uuid: String!) {
    rebootRoomDevice(sf_id: $sf_id, device_uuid: $device_uuid) {
      ... on TV {
        uuid
        reboot
      }
      ... on Chromecast {
        uuid
        reboot
      }
    }
  }
`

export const OPERATION_UPDATE_MESSAGE = gql`
  mutation UpdateMessage(
    $sf_id: String!
    $message_id: String!
    $title: String!
    $content: String!
  ) {
    message: updateMessage(
      sf_id: $sf_id
      message_id: $message_id
      title: $title
      content: $content
    ) {
      id
      site_sf_id
      title
      content
      enable
    }
  }
`
